import { render, staticRenderFns } from "./QuizBlockingSlide.vue?vue&type=template&id=2964f0f0&lang=pug"
import script from "./QuizBlockingSlide.vue?vue&type=script&lang=ts"
export * from "./QuizBlockingSlide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports